// hooks
import { useState, useEffect } from "react";

// react-bootstrap
import { Form, Button, Modal, Container } from "react-bootstrap";

// componentes
import { DropZoneFile } from "../../DropZoneFile";

//icons
import { MdOutlineFileCopy } from "react-icons/md";

// http services
import setDatos from "../../../../../services/setDatos";
import updateDatos from "../../../../../services/updateDatos";

// Variables de entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../../../../environment";

export const AdminManual = ({
  caractFiltro,
  idComponente,
  show,
  onHide,
  tituloModal,
  accion,
  listAyudas,
  objectEditarMan = null,
  setLoad,
}) => {
  const [rutaMan, setRutaMan] = useState("");

  const [dataManualAyuda, setDataManualAyuda] = useState({
    idAyuda: "",
    nombreAyuda: "",
    descripcionAyuda: "",
    prioridadAyuda: "",
    idTipoAyuda: 2,
    activoAyuda: false,
    destacadoAyuda: false,
  });

  const [manualUpload, setManualUpload] = useState("");

  useEffect(() => {
    if (accion === "Editar" && objectEditarMan) {
      setDataManualAyuda({
        idAyuda: objectEditarMan.id_ayuda,
        nombreAyuda: objectEditarMan.nombre,
        descripcionAyuda: objectEditarMan.descripcion,
        prioridadAyuda: objectEditarMan.prioridad,
        idTipoAyuda: 2,
        activoAyuda: objectEditarMan.activo,
        destacadoAyuda: objectEditarMan.destacado,
      });

      setRutaMan(
        `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${
          objectEditarMan.archivo?.split(".")[1]
        }.png`
      );
    } else {
      setDataManualAyuda({
        idAyuda: "",
        nombreAyuda: "",
        descripcionAyuda: "",
        prioridadAyuda: "",
        objectEditarMan: "",
        idTipoAyuda: 2,
        activoAyuda: false,
        destacadoAyuda: false,
      });

      setRutaMan("");
    }
  }, [objectEditarMan]);

  const handleChange = ({ target }) => {
    setDataManualAyuda({
      ...dataManualAyuda,
      [target.name]: target.type === "checkbox" ? target.checked : target.value,
    });
  };

  const handleChangePrioridad = ({ target }) => {
    if (/^-?\d*$/.test(target.value)) {
      if (target.value != "" && target.value < 1) {
        setDataManualAyuda({
          ...dataManualAyuda,
          [target.name]: target.type === "checkbox" ? target.checked : 100,
        });
      } else {
        setDataManualAyuda({
          ...dataManualAyuda,
          [target.name]:
            target.type === "checkbox" ? target.checked : target.value,
        });
      }
    }
  };

  const handleFileUpload = (manual) => {
    setManualUpload(manual);
  };

  const saveVideo = async (id) => {
    try {
      let formData = new FormData();

      formData.append("carpeta", idComponente);
      formData.append("subCarpeta", id);
      formData.append("archivos", manualUpload);

      await setDatos(`atributos/archivos`, formData);
    } catch (err) {
      alert("Error al subir el archivo");
    }
  };

  const saveManualAyuda = async () => {
    const { nombreAyuda, descripcionAyuda } = dataManualAyuda;

    if (!nombreAyuda || !descripcionAyuda) {
      alert("Los campos marcados con * son obligatorios");

      return;
    }

    if (accion === "Nuevo" && !manualUpload) {
      alert("Debe subir un archivo");
      return;
    }

    try {
      setLoad(true);
      if (accion === "Editar") {
        const { data: responseIds } = await updateDatos(
          `geomed/ayudas/${dataManualAyuda.idAyuda}`,
          dataManualAyuda
        );
        const { idAyuda } = responseIds;

        if (manualUpload) {
          await saveVideo(idAyuda);
          setManualUpload("");
        }
        alert("Registro actualizado exitosamente");
      } else {
        const { data: responseIds } = await setDatos(
          "geomed/ayudas",
          dataManualAyuda
        );
        const { idAyuda } = responseIds;

        if (manualUpload) {
          await saveVideo(idAyuda);
          setManualUpload("");
        }
        alert("Registro guardado exitosamente");
      }
      await listAyudas();
      onHide();
    } catch (error) {
      throw error;
    } finally {
      setLoad(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="md" id="modalAdminRegister">
      <Modal.Header closeButton>
        <Modal.Title>{tituloModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="pb-2">
          <Form.Group className="mb-3">
            <Form.Label className="label-forms-admin">
              Nombre <strong>*</strong>
            </Form.Label>
            <Form.Control
              type="text"
              className="inputs-forms-admin focus-admin-register"
              name={"nombreAyuda"}
              value={dataManualAyuda.nombreAyuda}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="label-forms-admin">
              Descripción <strong>*</strong>
            </Form.Label>
            <Form.Control
              as="textarea"
              className="inputs-forms-admin focus-admin-register textarea-form-admin"
              name={"descripcionAyuda"}
              onChange={handleChange}
              value={dataManualAyuda.descripcionAyuda}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="label-forms-admin">Prioridad</Form.Label>
            <Form.Control
              type={"text"}
              value={dataManualAyuda.prioridadAyuda}
              className="inputs-forms-admin focus-admin-register"
              name={"prioridadAyuda"}
              min={1}
              maxLength={25}
              onChange={handleChangePrioridad}
            />
          </Form.Group>
          <DropZoneFile
            extensiones={{
              "application/pdf": [],
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                [],
              "application/vnd.ms-excel": [],
              "application/vnd.ms-powerpoint": [],
              "application/msword": [".doc", ".docx"],
              "text/plain": [],
            }}
            tipoFile={"Archivo"}
            config={{
              icon: (
                <MdOutlineFileCopy
                  color="#2E2E2E"
                  size={"25px"}
                  className="mb-2"
                />
              ),
              message: "Arrastre o da clic para subir el archivo",
            }}
            onNewFile={handleFileUpload}
            rutaEdit={rutaMan}
            size={100}
          />
          <div className="container-accion-admin">
            <div className="container-checkbox-accion-admin">
              <Form.Check
                type="switch"
                onChange={handleChange}
                name={"activoAyuda"}
                checked={dataManualAyuda.activoAyuda}
              />
              <Form.Label
                className="label-forms-admin me-2"
                title="Proyecto original"
              >
                Activo
              </Form.Label>
              <Form.Check
                type="switch"
                name={"destacadoAyuda"}
                onChange={handleChange}
                checked={dataManualAyuda.destacadoAyuda}
              />
              <Form.Label className="label-forms-admin me-2" title="Destacado">
                Destacado
              </Form.Label>
            </div>
            <Button
              className="btn-geomedellin btn-register-admin btn-accion"
              onClick={saveManualAyuda}
            >
              Guardar
            </Button>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
};
